import React from 'react';
import TitleComponent from '../../common/titleComponent';
import { Divider, Paper } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const RolesList = ({ data: roles }) => {
  return (
    <Paper className='paper'>
      <TitleComponent entity={'Roles'} />
      <Divider />
      <div>
        <List dense={true}>
          {roles.length > 0 ? (
            roles.map((role) => (
              <ListItem divider key={role.id}>
                <ListItemText
                  primary={role.display_name}
                  secondary={
                    role.permissions.length > 0 && (
                      <>
                        <span variant='caption'>
                          Permisos:{' '}
                          {role.permissions
                            .map((p) => p.display_name)
                            .join(', ')}
                        </span>
                      </>
                    )
                  }
                />
              </ListItem>
            ))
          ) : (
            <ListItem>
              <ListItemText primary={'No tienes asignado un role'} />
            </ListItem>
          )}
        </List>
      </div>
    </Paper>
  );
};

export default RolesList;
